import { from, of } from "rxjs"
import { ofType } from "redux-observable"
import { switchMap, map, catchError, delay } from "rxjs/operators"
import { push } from "connected-react-router"

import {
    fetchShippmentFilterValuesSuccess,
    fetchCommentsSuccess,
    postCommentSuccess,
    fetchRejectReasonsSuccess,
    saveActionCodeSuccess,
    fetchWayBillInformationSuccess,
    fetchRailcarMovementsSuccess,
    fetchShipmentWaybillSuccess,
    getEbolTokenSuccess,
    clearWayBill,
    fetchTelegraphDataSucess,
    fetchTelegraphDataFailure,
    setDateRangeTELEGRAPH,
    getEbolTokenFailure,
    getCarSchedulingRailcarMovementsSuccess,
} from "./actions"

import * as userViewActions from "../userViews/actions"
import * as errorActions from "../error/actions"

import { hideLoader } from "../loader/actions"

import visibilityApi from "../../api/visibility-api"
import platformServiceAPI from "../../api/platform-service-eti-api"
import * as types from "./actionTypes"

import { findMaxETIandETA_TELE } from "../../constants/utils"

export function fetchShipperTrackDetails(action$) {
    return action$.pipe(
        ofType(types.VISIBILITY_SHIPMENT_LIST_FETCH_SUCCESS),
        switchMap(() => of(hideLoader()))
    )
}
export function fetchShipperFilterValues(action$) {
    return action$.pipe(
        ofType(types.VISIBILITY_SHIPPER_FILTER_VALUES_FETCH),
        switchMap((action) =>
            from(visibilityApi.getShipperFilterValues(action.payload)).pipe(
                switchMap((data) =>
                    of(fetchShippmentFilterValuesSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
export function fetchComments(action$) {
    return action$.pipe(
        ofType(types.VISIBILITY_FETCH_COMMENTS),
        switchMap((action) =>
            from(visibilityApi.getComments(action.payload.data)).pipe(
                switchMap((data) =>
                    of(fetchCommentsSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function postComment(action$) {
    return action$.pipe(
        ofType(types.VISIBILITY_POST_COMMENT),
        switchMap((action) =>
            from(visibilityApi.postComment(action.payload)).pipe(
                switchMap((data) => of(postCommentSuccess(data), hideLoader())),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchRejectReasonDetails(action$) {
    return action$.pipe(
        ofType(types.VISIBILITY_REJECT_REASONS_FETCH),
        switchMap((action) =>
            from(visibilityApi.getRejectReasons(action.payload)).pipe(
                switchMap((data) =>
                    of(fetchRejectReasonsSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
export function saveActionCode(action$) {
    return action$.pipe(
        ofType(types.VISIBILITY_SAVE_ACTION_CODE),
        switchMap((action) =>
            from(visibilityApi.saveActionCode(action.payload)).pipe(
                switchMap((data) =>
                    of(saveActionCodeSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchWayBillInformation(action$) {
    return action$.pipe(
        ofType(types.VISIBILITY_WAYBILL_INFORMATION_FETCH),
        switchMap((action) =>
            from(visibilityApi.GetWaybillInformation(action.payload)).pipe(
                switchMap((data) =>
                    of(fetchWayBillInformationSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchRailcarMovements(action$) {
    return action$.pipe(
        ofType(types.VISIBILITY_RAILCAR_MOVEMENTS_FETCH),
        switchMap((action) =>
            from(visibilityApi.GetRailcarMovements(action.payload)).pipe(
                switchMap((data) =>
                    of(fetchRailcarMovementsSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function getCarSchedulingRailcarMovements(action$) {
    return action$.pipe(
        ofType(types.VISIBILITY_GET_CAR_SCHEDULING_RAILCAR_MOVEMENTS),
        switchMap((action) =>
            from(
                visibilityApi.GetCarSchedulingRailcarMovements(action.payload)
            ).pipe(
                switchMap((data) =>
                    of(
                        getCarSchedulingRailcarMovementsSuccess(data),
                        hideLoader()
                    )
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchShipmentWaybill(action$) {
    return action$.pipe(
        ofType(types.VISIBILITY_SHIPMENT_WAYBILL_FETCH),
        switchMap((action) =>
            from(visibilityApi.GetShipmentWaybill(action.payload)).pipe(
                switchMap((data) =>
                    of(fetchShipmentWaybillSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function clearWaybill(action$) {
    return action$.pipe(
        ofType(types.VISIBILITY_SHIPMENT_WAYBILL_FETCH_SUCCESS),
        delay(1000),
        map(() => clearWayBill())
    )
}
export function fetchEbolToken(action$) {
    return action$.pipe(
        ofType(types.VISIBILITY_GET_EBOL_TOKEN),
        switchMap(() =>
            from(visibilityApi.getEbolToken()).pipe(
                switchMap((data) =>
                    of(getEbolTokenSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        getEbolTokenFailure(500), //returning response as 500 error code to match existing implementation in component
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function clearVisibiltiy(action$) {
    return action$.pipe(
        ofType(types.CLEAR_VISIBILITY_ALL),
        map(() => userViewActions.userViewClearAll())
    )
}

export function fetchTelegraphData(action$) {
    return action$.pipe(
        ofType(types.PLATFORM_SERVICE_FETCH),
        switchMap((action) =>
            from(
                platformServiceAPI.platformServiceETIdata(action.payload)
            ).pipe(
                switchMap((data) =>
                    of(
                        fetchTelegraphDataSucess(data),
                        setDateRangeTELEGRAPH(findMaxETIandETA_TELE(data))
                    )
                ),
                catchError((err) =>
                    of(fetchTelegraphDataFailure(err), hideLoader())
                )
            )
        )
    )
}
